import Modal from '@/components/shared/modal';
import Link from 'next/link';
import { useState, Dispatch, SetStateAction, useCallback, useMemo } from 'react';
import { getLocalizedPath } from '@/components/shared/formatURL';

type DownloadModalProps = {
  showDownloadModal: boolean;
  setShowDownloadModal: Dispatch<SetStateAction<boolean>>;
  translations: any;
};

const DownloadModal = ({
  showDownloadModal,
  setShowDownloadModal,
  translations
}: DownloadModalProps) => {
  const handleCancelButton = () => {
    setShowDownloadModal(false);
  };

  return (
    <Modal showModal={showDownloadModal} setShowModal={setShowDownloadModal}>
      <div className="w-full overflow-hidden border-0 border-[#3C3C3C] shadow-xl md:max-w-md md:rounded-2xl">
        <div className="flex flex-col items-center justify-center space-y-3 border-b-[0.5px] border-[#3C3C3C] bg-modal-grey px-4 py-6 text-center md:px-16">
          <p className="text-center font-semibold text-white ">{translations.downloadYourOwn}</p>
        </div>
        <div className="flex flex-row gap-4 bg-modal-grey px-4 py-6 md:px-16">
          <Link
            href={getLocalizedPath(`create`)}
            className="my-0 inline-flex h-10 w-full transform items-center justify-center whitespace-nowrap rounded-md bg-crp-red px-4 py-2 text-sm font-black text-white hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
          >
            {translations.generateNow}
          </Link>
        </div>
      </div>
    </Modal>
  );
};

export function useDownloadModal(translations: any) {
  const [showDownloadModal, setShowDownloadModal] = useState(false);

  const DownloadModalCallback = useCallback(() => {
    return (
      <DownloadModal
        showDownloadModal={showDownloadModal}
        setShowDownloadModal={setShowDownloadModal}
        translations={translations}
      />
    );
  }, [showDownloadModal, setShowDownloadModal]);

  return useMemo(
    () => ({ setShowDownloadModal, DownloadModal: DownloadModalCallback }),
    [setShowDownloadModal, DownloadModalCallback]
  );
}
